import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  AfterViewInit,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import { SkyTabsetService } from './tabset.service';


export class SkyTabComponent implements OnDestroy, AfterViewInit, OnChanges {
  
  public tabHeading: string;

  
  public tabHeaderCount: string;

  
  public disabled: boolean;

  
  public tabIndex: string | number;

  
  public active: boolean;

  public get allowClose(): boolean {
    return this.close.observers.length > 0;
  }

  
  public close = new EventEmitter<any>();

  constructor(private tabsetService: SkyTabsetService, private ref: ChangeDetectorRef) {}

  public ngAfterViewInit() {
    setTimeout(() => {
      this.tabsetService.addTab(this);

      this.tabsetService.activeIndex.subscribe((activeIndex: any) => {
        this.active = this.tabIndex === activeIndex;
        this.ref.markForCheck();
      });

      if (this.active) {
        this.tabsetService.activateTab(this);
      }
    });

  }

  public ngOnChanges(changes: SimpleChanges) {
    /* istanbul ignore else */
    /* sanity check */
    if (changes) {
      let activeChange = changes['active'];
      if (activeChange
        && this.tabIndex !== undefined
        && activeChange.previousValue !== activeChange.currentValue
        && this.active) {
        this.tabsetService.activateTab(this);
      }
    }
  }

  public ngOnDestroy() {
    this.tabsetService.destroyTab(this);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-tab',
  template: `<div class="sky-tab" [hidden]="!active" role="tabpanel">
  <ng-content></ng-content>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyTabsetService, },
{type: ChangeDetectorRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'tabHeading': [{ type: Input },],
'tabHeaderCount': [{ type: Input },],
'disabled': [{ type: Input },],
'tabIndex': [{ type: Input },],
'active': [{ type: Input },],
'close': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
